import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import OwlCarousel from 'react-owl-carousel';
import { useSelector, useDispatch } from 'react-redux';
import { removeMovie, FetMovieDetail, FetMovieSimilar } from "../Redux/action";
import { Tabs, Tab, Col, Row, OverlayTrigger, Tooltip } from 'react-bootstrap';
import DetailmovieSkeleton from "./detailmovieSkeleton";
import MovieHelmet from "../SEO/MovieHelmet";
import Downlown from "./Modal/downlown";
import Trailer from "./Modal/trailer";
import Watchnowmodal from "./Modal/watchnowModal";
import MovieItem from './../Home/movie_item';
const DetailMovie = () => {
    const { moviesId } = useParams();
    const movies = useSelector(state => state.DetailMovie);
    const similarmv = useSelector(state => state.SimilarMovies);
    const DetailMovies = movies?.MovieDetail;
    const SimilarMovies = similarmv.SimilarMV;
    const localStor = localStorage.getItem('theme');
    const dispatch = useDispatch();
    const [modalShow, setModalShow] = useState({ download: false, trailer: false, watchnowModal: false });
    useEffect(() => {
        if (moviesId || moviesId !== '')
            dispatch(FetMovieDetail(moviesId));
        dispatch(FetMovieSimilar(moviesId));
        console.log(1);
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        return () => {
            dispatch(removeMovie());
        }
    }, [moviesId, dispatch])
    const gen = DetailMovies?.genres;
    let genrelis = gen && gen.map((gen, index) => {
        return <span key={index} className="list-catagories">{gen} <i className="list">/</i> &nbsp;</span>
    });
    const qualitys = DetailMovies?.torrents;
    let qualitylist = qualitys?.map((qua) => {
        return (<> <span key={qua.index} className="px-2 rounded bg-warning fw-bol">{qua.quality} </span> &nbsp;</>)
    })
    return (
        <div>
            <MovieHelmet title={DetailMovies?.title} discripction={DetailMovies?.description_intro} />
            <div className="detail-page">
                <div className="background-images" style={{
                    backgroundImage: `${localStor === 'dark' ? `linear-gradient(rgb(33 37 41 / 0%) 0px, rgb(40 44 53) 80%), url(${DetailMovies?.background_image_original}` : `linear-gradient(rgb(33 37 41 / 0%) 0px, rgb(245 245 245) 80%), url(${DetailMovies?.background_image_original}`})`
                }}>
                    <div className="container"><br /><br /><br />
                        {!movies?.loading ?
                            <Row>
                                <Col xs={12} md={4}>
                                    <div className="bg-system rounded p-4 mb-2 pt-5 sticky-md-top sticky-lg-top sticky-xl-top">
                                        <div className="d-flex justify-content-center">
                                            <img src={DetailMovies?.large_cover_image ? DetailMovies?.large_cover_image : process.env.PUBLIC_URL + '/Thamnail.png'} alt="Cover" className="img-thumbnail shadow mx-xs-3 m-auto w-75 rounded" />
                                        </div>
                                        <div className="p-4 text-center">
                                            <h1 className="mb-3 text-warning">{DetailMovies?.title}</h1>
                                            <div className="mb-2">{genrelis}</div>
                                            <div className="mb-2">
                                                <span><b>Quality</b> {qualitylist}</span>&nbsp;&nbsp;
                                            </div>
                                            <div className="mb-2">
                                                <span className="rounded fw-bol"><b>Duration:</b> {DetailMovies?.runtime}min</span>
                                            </div>
                                            <div className="mb-2">
                                                <span className="rounded fw-bol"><b>Release date:</b> {DetailMovies?.year}</span>
                                            </div>
                                            <div className="mb-2">
                                                <span className="movie_info h4"><i className="icon-imdb"></i> <i className="bi bi-star-fill text-warning"></i> {DetailMovies?.rating}</span> &nbsp;&nbsp;
                                                <span className="movie_info h4"><i className="bi bi-download text-warning"></i> {DetailMovies?.download_count}</span>
                                            </div>
                                            <div className="mt-3">
                                                <button className="btn btn-warning w-75 text-white btn-lg fw-bol" onClick={() => setModalShow({ ...modalShow, download: true })}><i className="bi bi-download"></i> Download</button>
                                                <button className="btn btn-outline-warning w-75 mt-3 " onClick={() => setModalShow({ ...modalShow, trailer: true })}><i><i className="bi bi-youtube"></i> Trailer</i></button>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col xs={12} md={8} className="px-md-0">
                                    <div className="bg-system rounded p-4 mb-2">
                                        <div className="d-md-flex align-items-center justify-content-between mb-4 w-100">
                                            <h4 className="font-size-24 font-weight-medium m-0">Synopsis &nbsp;</h4>
                                            <div className="d-none d-md-block border-top-theme col p-0 mt-2 border-gray-6830"></div>
                                        </div>
                                        <p>{DetailMovies?.description_intro}</p>
                                    </div>
                                    <div className="bg-system rounded p-4 my-3">
                                        <Tabs defaultActiveKey={DetailMovies?.torrents[0].type === "web" ? "720p.web" : "720p.bluray"} id="uncontrolled-tab-example" className="border-0 list-tech-spece">
                                            <Tab eventKey="Tech specs" title="Tech specs" disabled />
                                            {DetailMovies?.torrents && DetailMovies?.torrents.map((file, index) => {
                                                return (
                                                    <Tab key={index} eventKey={file.quality + "." + file.type} title={file.quality + "." + file.type}>
                                                        <Row className="px-3 fw-bold">
                                                            <Col className="p-3 p-md-5" xs={6} md={3}>
                                                                <h6 className="m-0"><i className="bi bi-folder2-open"></i> {file.size}</h6>
                                                            </Col>
                                                            <Col className="p-3 p-md-5" xs={6} md={3}>
                                                                <OverlayTrigger overlay={<Tooltip>Click to download Subtitles</Tooltip>}>
                                                                    <h6 className="d-inline-block m-0">
                                                                        <a className="text-decoration-none h6" target="_blank" rel="noreferrer" href={`https://yifysubtitles.org/movie-imdb/${DetailMovies?.imdb_code}`}>
                                                                            <i className="bi bi-badge-cc"></i> Subtitles <i className="bi bi-exclamation-octagon text-warning"></i>
                                                                        </a>
                                                                    </h6>
                                                                </OverlayTrigger>
                                                            </Col>
                                                            <Col className="p-3 p-md-5" xs={6} md={3}>
                                                                <h6 className="m-0"><i className="bi bi-stopwatch"></i> {DetailMovies?.runtime}min</h6>
                                                            </Col>
                                                            <Col className="p-3 p-md-5" xs={6} md={3}>
                                                                <h6 className="m-0">P/S {file.peers} / {file.seeds}</h6>
                                                            </Col>
                                                        </Row>
                                                    </Tab>
                                                )
                                            })}
                                        </Tabs>
                                    </div>
                                    <div className="bg-system rounded p-4 my-3 container-card">

                                        <div className="d-md-flex align-items-center justify-content-between mb-1 pb-1 w-100">
                                            <h4 className="font-size-24 font-weight-medium m-0">Similar Movies &nbsp;</h4>
                                            <div className="d-none d-md-block border-top-theme col p-0 mt-2 border-gray-6830"></div>
                                        </div>
                                        <Row>
                                            <OwlCarousel className="owl-theme owl-slider" items={3} loop autoplay={true} dots={false}>
                                                {
                                                    SimilarMovies && SimilarMovies?.map((Movies, index) => {
                                                        return (
                                                            <Col className="p-1" key={index}>
                                                                <div className="item">
                                                                    <MovieItem {...Movies} />
                                                                </div>
                                                            </Col>
                                                        )
                                                    })
                                                }

                                            </OwlCarousel>
                                        </Row>
                                    </div>

                                </Col>
                            </Row> :
                            <DetailmovieSkeleton />
                        }
                    </div>
                </div>
            </div>
            <Watchnowmodal show={modalShow.watchnowModal} onHide={() => setModalShow({ ...modalShow, watchnowModal: false })} data={DetailMovies} />
            <Downlown show={modalShow.download} onHide={() => setModalShow({ ...modalShow, download: false })} data={DetailMovies} />
            <Trailer show={modalShow.trailer} onHide={() => setModalShow({ ...modalShow, trailer: false })} data={DetailMovies} />
        </div>
    )
}

export default DetailMovie;
